import PaginationFootballProperties from "../../../Football/Models/Pagination/PaginationFootballProperties";

export default class LeagueLeaderboardMetaModel {
  templateId: string = null;
  privateLeagueId: string = null;
  fromDate: string = null;
  toDate: string = null;
  pagination: PaginationFootballProperties = new PaginationFootballProperties();
}
